import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { useCallback } from 'react';

import { en } from '@/intl/en';

export type TranslationBlock = typeof en;

/**
 * Despite the first parameter of the returned callback being an object, you should be passing in an array.
 * The 0, 1, 2... keys are to make it sync up with the typing of an array.
 */
export const useAppFormatMessage = () => {
    const { formatMessage } = useIntl();

    return useCallback(
        <
            PrimaryId extends keyof TranslationBlock,
            SecondaryId extends keyof TranslationBlock[PrimaryId],
            TertiaryId extends keyof TranslationBlock[PrimaryId][SecondaryId],
            QuaternaryId extends keyof TranslationBlock[PrimaryId][SecondaryId][TertiaryId],
            QuinaryId extends keyof TranslationBlock[PrimaryId][SecondaryId][TertiaryId][QuaternaryId],
            SenaryId extends keyof TranslationBlock[PrimaryId][SecondaryId][TertiaryId][QuaternaryId][QuinaryId],
            SeptenaryId extends
                keyof TranslationBlock[PrimaryId][SecondaryId][TertiaryId][QuaternaryId][QuinaryId][SenaryId],
        >(
            {
                0: primaryId,
                1: secondaryId,
                2: tertiaryId,
                3: quaternaryId,
                4: quinaryId,
                5: senaryId,
                6: septenaryId,
            }: {
                0: PrimaryId;
                1?: SecondaryId;
                2?: TertiaryId;
                3?: QuaternaryId;
                4?: QuinaryId;
                5?: SenaryId;
                6?: SeptenaryId;
            },
            config?: Omit<Parameters<typeof formatMessage>[0], 'id'> & {
                values?: Parameters<typeof formatMessage>[1];
            }
        ) => {
            let translationKey: string = `${primaryId}`;
            if (secondaryId) {
                translationKey = `${translationKey}.${String(secondaryId)}`;
                if (tertiaryId) {
                    translationKey = `${translationKey}.${String(tertiaryId)}`;
                    if (quaternaryId) {
                        translationKey = `${translationKey}.${String(quaternaryId)}`;
                        if (quinaryId) {
                            translationKey = `${translationKey}.${String(quinaryId)}`;
                            if (senaryId) {
                                translationKey = `${translationKey}.${String(senaryId)}`;
                                if (septenaryId) {
                                    translationKey = `${translationKey}.${String(septenaryId)}`;
                                }
                            }
                        }
                    }
                }
            }
            return formatMessage(
                {
                    id: translationKey,
                    ...config,
                },
                config?.values
            );
        },
        [formatMessage]
    );
};
